import { render, staticRenderFns } from "./MyLoan.vue?vue&type=template&id=13b5a4be&scoped=true"
import script from "./MyLoan.vue?vue&type=script&lang=js"
export * from "./MyLoan.vue?vue&type=script&lang=js"
import style0 from "./MyLoan.vue?vue&type=style&index=0&id=13b5a4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5a4be",
  null
  
)

export default component.exports